import { render, staticRenderFns } from "./ReportBadges.vue?vue&type=template&id=076ca308&scoped=true&"
import script from "./ReportBadges.vue?vue&type=script&lang=js&"
export * from "./ReportBadges.vue?vue&type=script&lang=js&"
import style0 from "./ReportBadges.vue?vue&type=style&index=0&id=076ca308&scoped=true&lang=css&"
import style1 from "./ReportBadges.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076ca308",
  null
  
)

export default component.exports